module.exports = __webpack_public_path__ + "static/media/6.734cb4f6.svg";